import { render, staticRenderFns } from "./Not-found.vue?vue&type=template&id=7ef23d58&"
import script from "./Not-found.vue?vue&type=script&lang=js&"
export * from "./Not-found.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports